import QLVNBomb from "./QLVNBomb.vue";
import QLVNBombProperties from "./QLVNBombProperties.vue";
import QLVNBombProperty from "./default.json";

export default {
  install(Vue) {
    Vue.component(QLVNBomb.name, QLVNBomb);
    Vue.component(QLVNBombProperties.name, QLVNBombProperties);
    Vue.prototype.$QLVNBombProperties = QLVNBombProperty;
  },
};
